import type { FC } from 'react';
import React, { useCallback } from 'react';

import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import styles from './ChipSelect.module.scss';

interface ChipSelectProps {
	onSelect: (selected: string[]) => void;
	options: { label: string; value: string }[];
	selected: string[];
}

export const ChipSelect: FC<ChipSelectProps> = ({ onSelect, options, selected }) => {
	const handleClick = useCallback(
		(value: string) => {
			if (value === '') {
				onSelect([]);
				return;
			}
			const isSelected = selected.includes(value);
			const newSelected = isSelected ? selected.filter((v) => v !== value) : [...selected, value];
			onSelect(newSelected);
		},
		[onSelect, selected],
	);

	return (
		<div className={styles.chipGroup}>
			{options.map((option) => {
				const isActive = option.value === '' ? selected.length === 0 : selected.includes(option.value);
				return (
					<Chip
						key={option.value}
						label={option.label}
						onClick={() => handleClick(option.value)}
						selected={isActive}
						size="medium"
						variant="secondary"
					/>
				);
			})}
		</div>
	);
};
